module.exports = __webpack_public_path__ + "assets/b85a279f2e085a199fe21c6793d69966.svg";